import { PopoverContent as ChakraPopoverContent } from "@chakra-ui/react";

export const PopoverContent = ChakraPopoverContent;
